import { checkToken } from "../../utilities/users-service";
import { useEffect, useMemo, useState } from "react";
import "./UserShowPage.css"

import { getCases } from "../../utilities/cases-service";


// export default function UserShowPage ({user, setUser}) {
//     console.log(user)
//     return (
//     <div className="user-show-page-ctr">
//         <h1>{user?.name}</h1>
//         <div className="stats">
//             {/* <h4>Total Score:</h4> */}
//             {/* <p>{user?.totalScore}</p> */}
//             <h4>Completed Cases:</h4>
//             <p>{Object.keys(user.completedCases).length}</p>
//             {/* <h4>Correct Responses:</h4> */}
//             {/* <p>{user?.completedCases.correct}</p> */}
//             {/* <h4>Incorrect Responses:</h4>
//             <p>{user.completedCases.incorrect}</p> */}
//             <p></p>
//             <p></p>
//             <h4>Diagnosing Since:</h4>
//             <p>{new Date(user?.createdAt)?.toDateString()}</p>
//         </div>
//     </div>
//     );
    
//     }



// export default function UserShowPage({ user }) {
//     const [allCases, setAllCases] = useState([]);
//     const [loading, setLoading] = useState(true);
  
//     // normalize casesList to string ids
//     const completedIdSet = useMemo(() => {
//       const list = user?.completedCases?.casesList || [];
//       const ids = list.map((x) => (typeof x === "string" ? x : x?._id)).filter(Boolean);
//       return new Set(ids);
//     }, [user]);
  
//     useEffect(() => {
//       (async () => {
//         try {
//           const resp = await getCases(); // same util as IndexPage
//           if (Array.isArray(resp)) setAllCases(resp);
//         } catch (e) {
//           console.error("Failed to fetch cases:", e);
//         } finally {
//           setLoading(false);
//         }
//       })();
//     }, []);
  
//     const completedCases = useMemo(
//       () => allCases.filter((c) => completedIdSet.has(String(c._id))),
//       [allCases, completedIdSet]
//     );
  
//     // ---------- helpers ----------
//     const fmt = (d) => {
//       if (!d) return "—";
//       const dt = new Date(d);
//       return isNaN(dt.getTime())
//         ? "—"
//         : dt.toLocaleString(undefined, {
//             year: "numeric",
//             month: "short",
//             day: "2-digit",
//             hour: "2-digit",
//             minute: "2-digit",
//           });
//     };
  
//     const normalizeRanking = (ranking) => {
//       if (!ranking) return [];
//       try {
//         if (typeof ranking === "string") {
//           try {
//             const parsed = JSON.parse(ranking);
//             if (Array.isArray(parsed)) return parsed.map(String);
//           } catch {}
//           return ranking.split(",").map((s) => s.trim()).filter(Boolean);
//         }
//         if (Array.isArray(ranking)) return ranking.map(String);
//         return [String(ranking)];
//       } catch {
//         return [];
//       }
//     };
  
//     const readJSON = (key, fallback) => {
//       try {
//         const raw = localStorage.getItem(key);
//         return raw ? JSON.parse(raw) : fallback;
//       } catch {
//         return fallback;
//       }
//     };
  
//     const getPhaseNumbers = (caseId) => {
//       const keys = Object.keys(localStorage || {});
//       const re = new RegExp(`^case-${caseId}-phase-(\\d+)-(ranking|ai)$`);
//       const set = new Set();
//       keys.forEach((k) => {
//         const m = k.match(re);
//         if (m) set.add(Number(m[1]));
//       });
//       return Array.from(set).sort((a, b) => a - b);
//     };
  
//     const getPhaseData = (caseId, n) => {
//       const rKey = `case-${caseId}-phase-${n}-ranking`;
//       const aKey = `case-${caseId}-phase-${n}-ai`;
//       const ranking = normalizeRanking(localStorage.getItem(rKey) || []);
//       const ai = readJSON(aKey, []); // [{role, content, timestamp}]
//       return { ranking, ai };
//     };
  
//     // optional: show completion hint if you stored the flag
//     const getCompletedAt = (caseId) => {
//       const submitted = localStorage.getItem(`case-${caseId}-survey-submitted`);
//       if (!submitted) return null;
//       const ts = localStorage.getItem(`case-${caseId}-completedAt`);
//       return ts ? fmt(ts) : "✓ completed";
//     };
  
//     if (loading) return <div className="user-show-page-ctr">Loading…</div>;
  
//     return (
//       <div className="user-show-page-ctr">
//         <header className="user-header">
//           <div>
//             <h1>{user?.name ?? "User"}</h1>
//             <p className="user-meta">
//               Diagnosing since: <strong>{fmt(user?.createdAt)}</strong>
//             </p>
//           </div>
//           <div className="pill-stats">
//             <div className="pill">
//               <span className="pill-label">Completed Cases</span>
//               <span className="pill-value">{completedCases.length}</span>
//             </div>
//           </div>
//         </header>
  
//         {completedCases.length === 0 ? (
//           <div className="empty">
//             <p>No completed cases yet.</p>
//           </div>
//         ) : (
//           <div className="case-list">
//             {completedCases.map((c) => {
//               const caseId = String(c._id);
//               const phases = getPhaseNumbers(caseId);
//               const completedAt = getCompletedAt(caseId);
  
//               return (
//                 <details key={caseId} className="case-card" open>
//                   <summary className="case-summary">
//                     <div className="case-title">{c.title || `Case ${caseId}`}</div>
//                     <div className="case-date">
//                       {completedAt ? `Completed: ${completedAt}` : ""}
//                     </div>
//                   </summary>
  
//                   {phases.length === 0 ? (
//                     <div className="phase empty-phase">
//                       <p className="muted">
//                         No per-phase data found in this browser. (Did you complete this on another device or clear cache?)
//                       </p>
//                     </div>
//                   ) : (
//                     <div className="phase-list">
//                       {phases.map((n) => {
//                         const { ranking, ai } = getPhaseData(caseId, n);
//                         return (
//                           <div key={`${caseId}-phase-${n}`} className="phase">
//                             <div className="phase-head">
//                               <h3 className="phase-title">Phase {n}</h3>
//                             </div>
  
//                             <div className="phase-body">
//                               <div className="phase-section">
//                                 <h4>Your Ranking</h4>
//                                 {ranking.length === 0 ? (
//                                   <p className="muted">No ranking recorded.</p>
//                                 ) : (
//                                   <ol className="ranking-list">
//                                     {ranking.map((r, idx) => (
//                                       <li key={`${caseId}-p${n}-r${idx}`}>{r}</li>
//                                     ))}
//                                   </ol>
//                                 )}
//                               </div>
  
//                               <div className="phase-section">
//                                 <h4>AI Interaction</h4>
//                                 {Array.isArray(ai) && ai.length > 0 ? (
//                                   <div className="ai-log">
//                                     {ai.map((m, i) => (
//                                       <div key={`${caseId}-p${n}-m${i}`} className={`ai-msg role-${m.role ?? "other"}`}>
//                                         <div className="ai-meta">
//                                           <span className="role">{(m.role ?? "").toUpperCase()}</span>
//                                           {m.timestamp && <span className="time">{fmt(m.timestamp)}</span>}
//                                         </div>
//                                         <div className="ai-content">{m.content}</div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 ) : (
//                                   <p className="muted">AI wasn’t used in this phase.</p>
//                                 )}
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </details>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     );
//   }



/** Internal → User-facing grouping */
const PART_GROUPS = [
  { partLabel: "Part 1", beforeKey: "submissionOne",   afterKey: "submissionTwo"   },
  { partLabel: "Part 2", beforeKey: "submissionThree", afterKey: "submissionFour"  },
  { partLabel: "Part 3", beforeKey: "submissionFive",  afterKey: "submissionSix"   },
];

// adding temporarily 10.2025 for pilot
const labRows = [
  { section: "Blood" },
  { name: "Sodium", value: "140 mEq/L", range: "136-145" },
  { name: "Potassium", value: "3.7 mEq/L", range: "3.5-5.0" },
  { name: "Chloride", value: "98 mEq/L", range: "98-106" },
  { name: "Total CO2", value: "22 mEq/L", range: "23-28" },
  { name: "Glucose", value: "121 mg/dL", range: "70-99 fasting" },
  { name: "BUN", value: "75 mg/dL", range: "8-20" },
  { name: "Creatinine", value: "2.6 mg/dL", range: "0.5-1.1" },
  { name: "> baseline creatinine 3 months ago", value: "1.0 mg/dL", range: "0.5-1.1" },
  { name: "Calcium", value: "9.5 mg/dL", range: "8.6-10.2" },
  { name: "Albumin", value: "3.8 g/dL", range: "3.5-5.5" },
  { name: "WBC Count", value: "9.2K/uL", range: "4K-11K" },
  { name: "> abs. eosinophils", value: "430/uL", range: "<500" },
  { name: "Hemoglobin", value: "13.5 g/dL", range: "13-17" },
  { name: "Platelets", value: "320K/uL", range: "150K-450K" },
  { section: "Urine" },
  { name: "Protein-to-creatinine ratio (spot)", value: "0.4 g/g", range: "<0.2" },
  { name: "Albumin-to-creatinine ratio (spot)", value: "188 mg/g", range: "<30" },
  { name: "Sodium", value: "20 mEq/L", range: "variable" },
  { name: "Creatinine", value: "42 mg/dL", range: "variable" },
];

const labRows2 = [
  { section: "Blood" },
  { name: "Sodium", value: "139 mEq/L", range: "136-145" },
  { name: "Potassium", value: "4.6 mEq/L", range: "3.5-5.0" },
  { name: "Chloride", value: "106 mEq/L", range: "98-106" },
  { name: "Total CO2", value: "18 mEq/L", range: "23-28" },
  { name: "BUN", value: "65 mg/dL", range: "8-20" },
  { name: "Creatinine", value: "2.8 mg/dL", range: "0.5-1.1" },
  { name: "Albumin", value: "3.2 g/dL", range: "3.5-5.5" },
  { section: "Urine" },
  { name: "Sodium", value: "120 mEq/L", range: "variable" },
  { name: "Creatinine", value: "60 mg/dL", range: "variable" },
];


/** Convert rank objects/strings into a sorted array of string labels */
function normalizeRankings(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) {
    if (raw.length === 0) return [];
    const first = raw[0];
    if (typeof first === "string" || typeof first === "number") {
      return raw.map(String);
    }
    if (typeof first === "object") {
      const withRank = raw.filter(
        (r) => r && (typeof r.rank === "number" || typeof r.rank === "string")
      );
      const noRank = raw.filter(
        (r) => r && typeof r.rank !== "number" && typeof r.rank !== "string"
      );
      const sorted = withRank
        .slice()
        .sort((a, b) => Number(a.rank) - Number(b.rank))
        .map((r) => r?.label ?? r?.name ?? String(r));
      const tail = noRank.map((r) => r?.label ?? r?.name ?? JSON.stringify(r));
      return [...sorted, ...tail];
    }
  }
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? normalizeRankings(parsed) : [raw];
    } catch {
      return raw.split(",").map((s) => s.trim()).filter(Boolean);
    }
  }
  return [String(raw)];
}

function fmtDate(d) {
  if (!d) return "—";
  const dt = new Date(d);
  return isNaN(dt.getTime())
    ? "—"
    : dt.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
}

/** Build a display bundle from one submission */
function toDisplay(sub, submittedAtFallback) {
  if (!sub) return null;
  const rankings = normalizeRankings(sub.rankings);
  const ai =
    Array.isArray(sub.interactions) && sub.interactions.length
      ? sub.interactions.flatMap((turn) => {
          const out = [];
          if (turn.question) {
            out.push({
              role: "user",
              content: String(turn.question),
              timestamp: sub.submittedAt || submittedAtFallback,
            });
          }
          if (turn.response) {
            out.push({
              role: "assistant",
              content: String(turn.response),
              timestamp: sub.submittedAt || submittedAtFallback,
            });
          }
          return out;
        })
      : [];
  return {
    rankings,
    ai,
    rationale: sub.rationale || "",
    submittedAt: sub.submittedAt || submittedAtFallback || null,
  };
}

/** Heatmap helpers */
function buildHeatmap(rankCounts) {
  if (!rankCounts || typeof rankCounts !== "object") return null;
  const entries = Object.entries(rankCounts).filter(
    ([, v]) => Array.isArray(v) && v.every((n) => typeof n === "number")
  );
  if (entries.length === 0) return null;

  const labels = entries.map(([label]) => label);
  const matrix = entries.map(([, arr]) => arr.slice());
  const max = Math.max(0, ...matrix.flat().map((n) => Number(n) || 0));
  return { labels, matrix, max };
}
function cellColor(val, max) {
  if (!max || max <= 0) return "rgba(0,0,0,0)";
  const t = Math.max(0, Math.min(1, val / max));
  const lightness = 95 - t * 55; // 95% -> 40%
  const sat = 65;
  return `hsl(16 ${sat}% ${lightness}%)`;
}

/** Extract 3 Parts for this user (Before + After AI), include heatmap from AFTER */
function extractUserParts(caseDoc, userId) {
  const parts = [];
  for (const grp of PART_GROUPS) {
    const beforeSubs = caseDoc?.[grp.beforeKey]?.submissions || [];
    const afterSubs  = caseDoc?.[grp.afterKey]?.submissions  || [];
    const beforeMine = beforeSubs.find((s) => String(s.user) === String(userId));
    const afterMine  = afterSubs.find((s)  => String(s.user) === String(userId));
    const afterRankCounts = caseDoc?.[grp.afterKey]?.rankCounts || null;

    if (!beforeMine && !afterMine && !afterRankCounts) continue;

    parts.push({
      partLabel: grp.partLabel,
      before: toDisplay(beforeMine),
      after:  toDisplay(afterMine, beforeMine?.submittedAt),
      heatmap: buildHeatmap(afterRankCounts),
    });
  }
  return parts;

}

/** Heatmap table (no external libs) */
function HeatmapTable({ labels, matrix, max }) {
  const colCount = matrix?.[0]?.length || 0;
  const colHeaders = Array.from({ length: colCount }, (_, i) => `Rank ${i + 1}`);
  return (
    <div className="heatmap-wrap">
      <div className="heatmap-grid" style={{ gridTemplateColumns: `120px repeat(${colCount}, 48px)` }}    >
        {/* header row */}
        <div className="hm-cell hm-header" />
        {colHeaders.map((h, i) => (
          <div key={`h-${i}`} className="hm-cell hm-header">{h}</div>
        ))}
        {/* rows */}
        {labels.map((label, r) => (
          <FragmentRow key={`row-${r}-${label}`} label={label} row={matrix[r]} max={max} />
        ))}
      </div>
    </div>
  );
}
function FragmentRow({ label, row, max }) {
  return (
    <>
      <div className="hm-cell hm-rowhdr">{label}</div>
      {row.map((val, c) => (
        <div
          key={`cell-${label}-${c}`}
          className="hm-cell hm-val"
          title={`${label} @ Rank ${c + 1}: ${val}`}
          style={{ background: cellColor(val, max) }}
        >
          <span className="hm-num">{val}</span>
        </div>
      ))}
    </>
  );
}

function fmtDay(d) {
    if (!d) return "—";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return "—";
    // e.g., "Oct 5, 2025"
    return dt.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }



export default function UserShowPage({ user }) {
  const [allCases, setAllCases] = useState([]);
  const [loading, setLoading] = useState(true);

  // caret states: expanded per case/part
  const [expandedAI, setExpandedAI] = useState({});     // key: `${caseId}:${partIdx}`
  const [expandedHM, setExpandedHM] = useState({});     // key: `${caseId}:${partIdx}`

  const toggleAI = (k) => setExpandedAI((s) => ({ ...s, [k]: !s[k] }));
  const toggleHM = (k) => setExpandedHM((s) => ({ ...s, [k]: !s[k] }));

  const completedIdSet = useMemo(() => {
    const list = user?.completedCases?.casesList || [];
    return new Set(
      list.map((x) => (typeof x === "string" ? x : x?._id)).filter(Boolean)
    );
  }, [user]);

  useEffect(() => {
    (async () => {
      try {
        const resp = await getCases();
        if (Array.isArray(resp)) setAllCases(resp);
      } catch (e) {
        console.error("Failed to fetch cases:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const myCompletedCases = useMemo(
    () => allCases.filter((c) => completedIdSet.has(String(c._id))),
    [allCases, completedIdSet]
  );

  if (loading) return <div className="user-show-page-ctr">Loading…</div>;

  return (
    <div className="user-show-page-ctr">
      <header className="user-header">
        <div>
          <h1>{user?.name ?? "User"}</h1>
          <p className="user-meta">
            Diagnosing Since: <strong>{fmtDay(user?.createdAt)}</strong>

          </p>
        </div>
        <div className="pill-stats">
          <div className="pill">
            <span className="pill-label">Completed Cases: &nbsp;</span>
           <strong className="pill-value">{myCompletedCases.length} </strong> 
          </div>
          <br></br>
          <br></br>

        </div>
      </header>

      {myCompletedCases.length === 0 ? (
        <div className="empty"><p>No completed cases yet.</p></div>
      ) : (
        <div className="case-list">
          {myCompletedCases.map((c) => {
            const parts = extractUserParts(c, user?._id);

            return (
              <details key={c._id} className="case-card">
                <summary className="case-summary">
                    <br></br>
                    <br></br>
                  <div className="case-title"><strong>Review Case Submission:  {c.title || `Case ${c._id}`}</strong> </div>
                  <br></br>
                  {/* <div className="case-date">Case Created {fmtDay(c.createdAt)}</div> */}
                  <br></br>


                </summary>


                {parts.length === 0 ? (
                  <div className="phase empty-phase">
                    <p className="muted">No submissions from you were found for this case.</p>
                  </div>
                ) : (
                  <div className="phase-list">


<div>
                <h4 className="case-left-format">Case Part I</h4>
                  <p className="case-left-format" >A 65-year-old man presents to the emergency department with acute kidney injury. For the past three days, the patient has experienced general malaise with intermittent lightheadedness and nausea. He has had reduced intake and vomited once yesterday, but he denies any diarrhea, abdominal pain, or dyspnea. Although the patient has no flank pain or frank burning with urination, he has difficulty initiating his urinary stream. His past medical history includes hypertension, type 2 diabetes mellitus, atrial fibrillation, benign prostatic hyperplasia, and a history of renal cell carcinoma, for which he underwent a right radial nephrectomy 18 years ago. His home medications include metoprolol succinate 25 mg daily, amlodipine 10 mg daily, metformin 1000 mg twice daily, and finasteride 5 mg daily. Last year, he went to his primary care physician with several days of back pain that he thought may have been a kidney stone, but this was never confirmed on imaging, and he has never had prior known episodes of nephrolithiasis. Four months ago, he was admitted to the hospital for five days with pneumonia. More recently, he was treated at an urgent care facility ten days ago for a “toe and foot infection” with oral cephalexin, which he is still taking for a two-week course. He denies any other recent medication changes, and he does not take NSAIDs. Vital signs show a temperature of 98 deg. F, a blood pressure of 132/76 mm Hg, and pulse of 84 /min. Physical exam is notable for clear lungs, a JVP of 6 cm, an irregularly irregular heart rhythm, no abdominal or CVA tenderness, trace lower extremity edema, and no skin findings aside from a shallow ulcer on the right great toe that appears clean and nearly healed without any  surrounding erythema. Initial chemistries in the emergency department reveal the following:</p>

                
                  <div className="labtable-wrap-user-show">
                    <table className="labtable">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Value</th>
                          <th>Ref. Range</th>
                        </tr>
                      </thead>
                      <tbody>
                        {labRows.map((r, i) =>
                          r.section ? (
                            <tr key={`sec-${i}`} className="section-row">
                              <td className="section-label"><strong>{r.section}</strong></td>
                              <td aria-hidden="true">&nbsp;</td>
                              <td aria-hidden="true">&nbsp;</td>
                            </tr>
                          ) : (
                            <tr key={`row-${i}`}>
                              <td>{r.name}</td>
                              <td>{r.value}</td>
                              <td>{r.range}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
            </div>

            <p className="case-left-format">Urine dipstick reveals trace leukocytes, 1+ protein, and negative for heme</p>

<br></br>
            <h4 className="case-left-format">Case Part 2</h4>

<p className="case-left-format">A retroperitoneal ultrasound shows a 10.5 cm left kidney without any evidence of hydronephrosis or stones and an absence of a right kidney</p>


<p className="case-left-format">The patient receives 2L of 0.9% Normal Saline. Repeat Chemistries 12 hours later demonstrate the following:</p>


<div className="labtable-wrap-user-show">
    <table className="labtable">
      <thead>
        <tr>
          <th></th>
          <th>Value</th>
          <th>Ref. Range</th>
        </tr>
      </thead>
      <tbody>
        {labRows2.map((r, i) =>
          r.section ? (
            <tr key={`sec-${i}`} className="section-row">
              <td className="section-label"><strong>{r.section}</strong></td>
              <td aria-hidden="true">&nbsp;</td>
              <td aria-hidden="true">&nbsp;</td>
            </tr>
          ) : (
            <tr key={`row-${i}`}>
              <td>{r.name}</td>
              <td>{r.value}</td>
              <td>{r.range}</td>
            </tr>
          )
        )}
      </tbody>
    </table>
  </div>

  <br></br>
  <br></br>
  <h4 className="case-left-format">Case Part 3</h4>


  <p className="case-left-format">Urine sediment microscopy reveals 30 white blood cells /hpf, and a white blood cell cast is identified.</p>
<p className="case-left-format">Urine culture is sent and returns negative 48 hours later</p>

</div>

<br></br>
<h3>Your Submissions</h3>


                    {parts.map((p, idx) => {
                      const key = `${c._id}:${idx}`;
                      const aiOpen = !!expandedAI[key];
                      const hmOpen = !!expandedHM[key];

                      return (

          
                        <div key={`${c._id}-part-${idx}`} className="phase">
                          <div className="phase-head">

<br></br>

                            <div className="phase-title case-left-format title-bigger"><strong>{p.partLabel} Submission - </strong>  {fmtDate(p.after?.submittedAt)}</div>

                            <br></br>


                            <br></br>
                          </div>

                          {/* Rankings side-by-side */}
                          <div className="rankings-grid case-left-format">
                            <div className="rank-col">
                             <strong>Ranking Before AI</strong>
                              {/* <div className="phase-meta">Submitted: {fmtDate(p.before?.submittedAt)}</div> */}
                              {p.before?.rankings?.length ? (
                                <ol className="ranking-list">
                                  {p.before.rankings.map((r, i) => (
                                    <li key={`${c._id}-part${idx}-before-r${i}`}>{r}</li>
                                  ))}
                                </ol>
                              ) : (
                                <p className="muted">No ranking recorded.</p>
                              )}
                            </div>

                            <div className="rank-col">
                            <strong>Ranking After AI</strong>
                              {/* <div className="phase-meta">Submitted: {fmtDate(p.after?.submittedAt)}</div> */}
                              {p.after?.rankings?.length ? (
                                <ol className="ranking-list">
                                  {p.after.rankings.map((r, i) => (
                                    <li key={`${c._id}-part${idx}-after-r${i}`}>{r}</li>
                                  ))}
                                </ol>
                              ) : (
                                <p className="muted">No ranking recorded.</p>
                              )}
                            </div>
                          </div>

                          <br></br>
    
                          {(p.after?.rationale || p.before?.rationale) && (
                            <div className="phase-section case-left-format">
                               <p> <strong>{p.partLabel} Rationale: </strong> {p.after?.rationale || p.before?.rationale}</p>
                            </div>
                          )}

              
    
                                            

                          <br></br>

                          {/* Collapsible Crowd Heatmap */}
                          <div className="phase-section">
                            <button
                              type="button"
                              className="caret-btn"
                              onClick={() => toggleHM(key)}
                              aria-expanded={hmOpen}
                            >
                              <span className={`caret ${hmOpen ? "open" : ""}`} aria-hidden>▸</span>
                              <span>Class DDx Rankings</span>
                            </button>

                            {hmOpen && (
                              p.heatmap ? (
                                <HeatmapTable
                                  labels={p.heatmap.labels}
                                  matrix={p.heatmap.matrix}
                                  max={p.heatmap.max}
                                />
                              ) : (
                                <p className="muted">No aggregate ranking data available.</p>
                              )
                            )}
                          </div>

                          <br></br>

                          {/* Collapsible AI interactions (from After AI) */}
                          <div className="phase-section">
                            <button
                              type="button"
                              className="caret-btn"
                              onClick={() => toggleAI(key)}
                              aria-expanded={aiOpen}
                            >
                              <span className={`caret ${aiOpen ? "open" : ""}`} aria-hidden>▸</span>
                              
                              <span>Your AI Interactions</span>
                            </button>


                            {aiOpen && (
                              p.after?.ai?.length ? (
                                <div className="ai-log">
                                  {p.after.ai.map((m, i) => (
                                    <div
                                      key={`${c._id}-part${idx}-ai-m${i}`}
                                      className={`ai-msg role-${m.role}`}
                                    >
                                      <div className="ai-meta">
                                        <span className="role">{m.role.toUpperCase()}</span>
                                        &nbsp; {m.timestamp && <span className="time">{fmtDate(m.timestamp)}</span>}
                                      </div>
                                      <div className="ai-content">{m.content}</div>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <p className="muted">AI wasn’t used in this part.</p>
                              )
                            )}
                          </div>

                          {/* Optional rationale (show compact, non-collapsed) */}


                    <br></br>
                    <br></br>


                        </div>


                      );

                    })}
                  </div>
                )}
              </details>
            );


          })}

        </div>

      )}
    

    </div>

  );
}
